<script lang="ts">
  type Grade = 'a' | 'b' | 'c' | 'd' | 'f';
  type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

  const grades: Grade[] = ['a', 'b', 'c', 'd', 'f'];
  const sizes: Size[] = ['xl', 'lg', 'md', 'sm', 'xs'];
  const modifiers = ['', '+', '−'];

  function randomGrade(grade: Grade): { letter: string; modifier: string } {
    const modifier = modifiers[Math.floor(Math.random() * modifiers.length)];
    return { letter: grade.toUpperCase(), modifier };
  }
</script>

<div class="bg-background p-4">
  <article class="w-full bg-card rounded-lg shadow-md p-8">
    <header class="mb-8">
      <h1 class="text-3xl font-bold text-foreground mb-2">Report Card Grade Sizes</h1>
      <p class="text-muted-foreground">Grade sizing examples at different scales</p>
    </header>

    <div class="overflow-x-auto">
      <table class="w-full border-collapse">
        <thead>
          <tr class="border-b">
            <th class="text-left py-3 px-4 font-semibold text-foreground">Size</th>
            {#each grades as grade (grade)}
              <th class="text-center py-3 px-4 font-semibold text-foreground">{grade.toUpperCase()}</th>
            {/each}
            <th class="text-center py-3 px-4 font-semibold text-foreground">NA</th>
          </tr>
        </thead>
        <tbody>
          {#each sizes as size (size)}
            <tr class="border-b hover:bg-muted/50">
              <td class="py-4 px-4 font-medium text-foreground uppercase">{size}</td>
              {#each grades as grade (grade)}
                {@const { letter, modifier } = randomGrade(grade)}
                <td class="text-center py-4 px-4">
                  <div class="grade-{size} grade-{grade}-{size}">
                    <span class="leading-none">{letter}</span>
                    {#if modifier}
                      <span class="text-[0.85em] self-start leading-none mt-[0.25em] ml-[0.08em]">{modifier}</span>
                    {/if}
                  </div>
                </td>
              {/each}
              <td class="text-center py-4 px-4">
                <div class="grade-{size} grade-unknown-{size}">NA</div>
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  </article>
</div>
